import * as React from 'react';
import type { StepManagerFooterProps } from './step-manager.types';
import { ChevronLeft, ChevronRight } from '@components/atoms';
import { Button, ButtonVariant } from '@components/molecules';

export const StepManagerFooter: React.VoidFunctionComponent<StepManagerFooterProps> = ({
	isValid,
	showBack,
	onContinue,
	onBack,
	backLabel = 'Back',
	continueLabel = 'Continue',
	isLoading,
}) => (
	<div
		className="flex shrink-0 gap-3 border-t border-borderPrimary bg-white p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0px_-12px_20px_4px_rgba(13,71,116,0.08)]"
		data-testid="step-manager-footer"
	>
		{showBack && (
			<Button
				type="button"
				variant={ButtonVariant.SECONDARY_NEW}
				onClick={onBack}
				className="flex h-12 flex-1 justify-center gap-1 p-4"
				disabled={isLoading}
			>
				<ChevronLeft className="size-5 shrink-0" />
				{backLabel}
			</Button>
		)}
		<Button
			type="button"
			variant={ButtonVariant.PRIMARY_NEW}
			onClick={onContinue}
			disabled={!isValid}
			className="flex h-12 flex-1 justify-center gap-1 border border-primary p-4"
			isLoading={isLoading}
		>
			{continueLabel}
			<ChevronRight className="size-5 shrink-0" />
		</Button>
	</div>
);
